import DateTime from 'react-datetime';
import './react-datetime.css';

const CustomDateTime = (props) => {
  return <DateTime {...props} />;
};

export default CustomDateTime;
